import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {TheBorderGameAssets} from "../TheBorderGameAssets";
import {TheBorder} from "../TheBorder";
import {TheBorderStatics} from "../TheBorderStatics";
import {TheBorderSound} from "../sound/TheBorderSound";
import {TheBorderGameMode} from "../server/TheBorderGameMode";

/**
 * Created by Jerker Nord on 2022-04-08.
 */

export class TheBorderWinMultiplierView extends PIXI.Container implements StageLayer {

    private static WIN_MULTIPLIER_POSITION_MAIN_GAME:PIXI.Point = new PIXI.Point(570, -112);
    private static WIN_MULTIPLIER_POSITION_FS:PIXI.Point = new PIXI.Point(450, -146);
    private static WIN_MULTIPLIER_POSITION_SUPER_FS:PIXI.Point = new PIXI.Point(522, -147);

    private _winMultiplierText:PIXI.BitmapText;
    private _sfsWinMultiplierText:PIXI.BitmapText;
    private _winMultiplierContainer:PIXI.Container;
    private _winMultiplierBackground:PIXI.Sprite;
    private _winMultiplierValue:number;

    constructor() {
        super();
        this.name = "TheBorderWinMultiplierView";
        this.position = TheBorderStatics.MAIN_REELS_VIEW_POSITION;
        this.init();
    }

    private init() {
        this._winMultiplierContainer = new PIXI.Container();
        this.addChild(this._winMultiplierContainer);

        this._winMultiplierBackground = new PIXI.Sprite(TheBorder.assetLoader.getTextures(TheBorderGameAssets.WIN_MULTIPLIER_BACKGROUND)[0]);
        this._winMultiplierBackground.position.set(0, 0);
        this._winMultiplierContainer.addChild(this._winMultiplierBackground);

        this._winMultiplierValue = TheBorder.model.initData.currentMultiplier;
        this._winMultiplierText = new PIXI.BitmapText("x" + this._winMultiplierValue, {
            fontName : TheBorderGameAssets.BITMAP_FONT_MULTIPLIER_NUMBERS,
            fontSize : 56
        });
        this._winMultiplierText.anchor = new PIXI.Point(0.5, 0.5);
        this._winMultiplierText.position.set(40, 35);
        this._winMultiplierContainer.addChild(this._winMultiplierText);

        this._sfsWinMultiplierText = new PIXI.BitmapText("x" + this._winMultiplierValue, {
            fontName : TheBorderGameAssets.BITMAP_FONT_SFS_MULTIPLIER_NUMBERS,
            fontSize : 13
        });
        this._sfsWinMultiplierText.anchor = new PIXI.Point(0.5, 0.5);
        this._sfsWinMultiplierText.position.set(44, 36);
        this._sfsWinMultiplierText.visible = false;
        this._winMultiplierContainer.addChild(this._sfsWinMultiplierText);

        this.adjustFontSize();

        if(TheBorder.model.data.mode == TheBorderGameMode.NORMAL || TheBorder.model.data.mode == TheBorderGameMode.NORMAL_AVALANCHE) {
            this.activateMainGameMultiplier();
        } else if(TheBorder.model.data.mode == TheBorderGameMode.FREESPIN || TheBorder.model.data.mode == TheBorderGameMode.FREESPIN_AVALANCHE) {
            this.activateFSWinMultiplier();
        }else{
            this.activateSFSWinMultiplier();
        }
    }

    public addToWinMultiplier(value:number, canPlaySound: boolean = true):void {
        if (canPlaySound) {
            this.playMultiplierUpSound();
        }
        this._winMultiplierValue += value;
        this._winMultiplierText.text = "x" + this._winMultiplierValue.toString();
        this._sfsWinMultiplierText.text = "x" + this._winMultiplierValue.toString();
        this.adjustFontSize();
    }

    public setWinMultiplier(value:number):void {
        this._winMultiplierValue = value;
        this._winMultiplierText.text = "x" + this._winMultiplierValue.toString();
        this._sfsWinMultiplierText.text = "x" + this._winMultiplierValue.toString();
        this.adjustFontSize();
    }

    public activateSFSWinMultiplier():void {
        this._winMultiplierBackground.visible = false;
        this._winMultiplierText.visible = false;
        this._sfsWinMultiplierText.visible = true;
        this._winMultiplierContainer.position = TheBorderWinMultiplierView.WIN_MULTIPLIER_POSITION_SUPER_FS;
        this.adjustFontSize();
    }

    public activateFSWinMultiplier():void {
        this._winMultiplierBackground.visible = false;
        this._winMultiplierText.y = 40;
        this._winMultiplierText.angle = -21;
        this._winMultiplierContainer.position = TheBorderWinMultiplierView.WIN_MULTIPLIER_POSITION_FS;
        this.adjustFontSize();
    }

    public activateMainGameMultiplier():void {
        this._winMultiplierBackground.visible = true;
        this._winMultiplierText.y = 35;
        this._winMultiplierText.angle = 0;
        this._winMultiplierText.visible = true;
        this._sfsWinMultiplierText.visible = false;
        this._winMultiplierContainer.position = TheBorderWinMultiplierView.WIN_MULTIPLIER_POSITION_MAIN_GAME;
        this.adjustFontSize();
    }

    private playMultiplierUpSound():void {
        TheBorder.soundPlayer.playSound(TheBorderSound.MULTIPLIER_UP_SOUNDS[Math.floor(Math.random() * TheBorderSound.MULTIPLIER_UP_SOUNDS.length)]); //#245
    }

    private adjustFontSize():void {
        this._winMultiplierText.fontSize = 56;

        while(this._winMultiplierText.textWidth > 64) {
            this._winMultiplierText.fontSize--;
            this._winMultiplierText.dirty = true;
            this._winMultiplierText.updateTransform();
        }

        while(this._sfsWinMultiplierText.textWidth > 70) {
            this._sfsWinMultiplierText.fontSize--;
            this._sfsWinMultiplierText.dirty = true;
            this._sfsWinMultiplierText.updateTransform();
        }
    }
}